import { render, staticRenderFns } from "./inviteReg2.vue?vue&type=template&id=0dd0956c&"
import script from "./inviteReg2.vue?vue&type=script&lang=js&"
export * from "./inviteReg2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports